const headers = [
  { text: 'Câu lạc bộ', value: 'name' },
  { text: 'Số lượng học sinh tối đa', value: 'maxMembers' },
  { text: 'Số lượng học sinh hiện tại', value: 'countMembers' },
  { text: 'Thao tác', value: 'actions', width: '80px' }
]

export { headers }
